import "../styles/global.css";
import Tarot from "../components/Tarot";

const TarotReading = ({ cards }) => {

  return (
      <Tarot/>
  );
};


export default TarotReading;
